import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {Routes, RouterModule} from '@angular/router';
import { NotFoundComponent } from './shared/not-found/not-found.component';
import { ProveedoresComponent } from './inicio/proveedores/proveedores.component';


const appRoutes: Routes = [
  {
    path: 'inicio',
    loadChildren: './home/home.module#HomeModule',
    //canLoad: [AuthGuard]
  },
  {
    path: 'impuestos',
    loadChildren : './impuestos/impuestos.module#ImpuestosModule',
    //canLoad: [AuthGuard]
  },
  {
    path: 'notificaciones',
    loadChildren : './notificacion/notificacion.module#NotificacionModule',
    //path:'notificaciones',
    //loadChildren: ()=> import('./notificacion/notificacion.module').then(m=> m.NotificacionModule)

  },
 /* {
    path: 'supplier',
    loadChildren : './supplier/supplier.module#SupplierModule',
    canLoad: [AuthGuard]
  },
  {
      path: 'login',
      component: LoginComponent
  },
  { path: 'logout', component: LogoutComponent },*/
  { path: 'proveedores', component:ProveedoresComponent },
  {
    path: '', redirectTo:  '/inicio', pathMatch: 'full'
  },
  {
    path: '**', component: NotFoundComponent
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(appRoutes)
  ],
  exports: [RouterModule],
  declarations: []
})
export class AppRoutingModule { }
